// Extend namespace by creating a new object
pyzel.fullwidthVideo = {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.fullwidthVideo.init = function() {

	$('.js-fullwidth-video-play').click(function(e){
		e.preventDefault();
		pyzel.fullwidthVideo.play( $(this) );
	});

};



/**
 * Play video
 *
 * @param {object} el Element clicked
 *
 * @return {void}
 */
pyzel.fullwidthVideo.play = function(el) {

	var
		videoPlaceholder = $('.js-fullwidth-video-placeholder'),
		sliderHeight = el.outerHeight()
	;

	// Reset CSS of placeholder
	videoPlaceholder.css('display', 'none');
	videoPlaceholder.css('position', 'absolute');
	videoPlaceholder.css('width', '100%');
	videoPlaceholder.css('height', '100%');
	videoPlaceholder.css('top', 0);
	videoPlaceholder.css('left', 0);
	videoPlaceholder.css('z-index', 1050); // Because of bootstrap fixed to top menu

	// Show video placeholder and scroll to top
	videoPlaceholder.fadeIn();
	$('html, body').animate({
		scrollTop: videoPlaceholder.offset().top
	}, 'slow');

	// Set iframe inside video placeholder and play video
	videoPlaceholder.html('<iframe src="https://player.vimeo.com/video/'+ el.data('vimeo-id') +'?autoplay=1&api=1&player_id=fullwidth-video-iframe" id="fullwidth-video-iframe" width="100%" height="' + $(window.top).height() + '" frameborder="0" allowfullscreen></iframe>');

	// Access the iframe so we can add events
	var iframe = $('#fullwidth-video-iframe')[0];
	var player = $f(iframe);

	// When the player is ready, add listeners
	player.addEvent('ready', function() {

		console.log('player is ready');
		
		// buggy on local version? maybe some css issue?
		setTimeout(function(){

			$(window).on('scroll', function() {
				/*
				videoPlaceholder.css('height', sliderHeight);
				videoPlaceholder.css('top', 'auto');
				videoPlaceholder.css('left', 'auto');
				videoPlaceholder.css('z-index', 9);
				$('#fullwidth-video-iframe').css('height', sliderHeight);
				*/

				// force finish on scroll - testing
				//onFinish();
				//console.log('on finish?');

			});

		}, 2000);
		

		player.addEvent('finish', onFinish);
	});

	function onFinish() {

		console.log('on finish was called');

		videoPlaceholder.fadeOut(100);

		//$(window).off('scroll');

		// trying to fix a layout bug that appears after the video is added.
		pyzel.quiver.init();

	}


};